module.exports = ".ck-widget.checkbox{display:inline-block;transform:scale(1.5)}.ck-widget.checkbox:focus,.ck-widget.checkbox:hover{cursor:pointer}"